import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const VerifyCleaner = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const Navigate = useNavigate();

  const verifyUser = async () => {
    if (!id) return;
    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/api/invitations/accept/${id}/`
      );
      setMessage(response.data.message || "Verification successful!");
      sessionStorage.setItem("invitation_id", id);
      Navigate("/invitation-status");
    } catch (error) {
      setMessage(error.response?.data?.message || "Verification failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex  items-center justify-center w-full h-[100vh] ">
      <div className="bg-[#FFF5CE] flex flex-col items-center justify-center px-10 py-20 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold mb-6">
          Thank you. Your email address has been verified. Please return to the
          HouseKeeper app to complete the registration process.{" "}
        </h1>
        <button
          disabled={loading}
          onClick={verifyUser}
          className="w-[300px] h-[50px] bg-[#586989] text-white p-2 rounded font-medium mt-5"
        >
          {loading ? "Verifying..." : "Verify your account"}
        </button>
        <p className="mt-4">{message}</p>
      </div>
    </div>
  );
};

export default VerifyCleaner;
